import { UseQueryResult, useQuery } from 'react-query';
import { PackageCategoryAutoComplete } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalPackageCategoriesProps {
  gym?: string;
}

export default function useSalesPortalPackageCategories({
  gym,
}: IUseSalesPortalPackageCategoriesProps): UseQueryResult<{ data: PackageCategoryAutoComplete[] }> {
  return useQuery(
    ['salesPortalPackageCategories', gym],
    () => client.get(`sales-portal/gyms/${gym}/package-categories/`),
    {
      enabled: !!gym,
    },
  );
}
